
export const MAX_USERNAME_LENGTH = 20;
export const MAX_DISPLAY_NAME_LENGTH = 16;


export function getUsernameError(name: string): string | null {
    if (name.length < 3)
        return "Username must be at least 3 characters long";
    if (name.length > MAX_USERNAME_LENGTH)
        return `Username cannot be longer than ${MAX_USERNAME_LENGTH} characters`;
    if (/^[A-Z]+$/.test(name[0]))
        return "Usernames must be lowercase";
    if (!/^[a-z]+$/.test(name[0]))
        return "Usernames must start with a letter";
    if (!/^[a-z0-9_]+$/.test(name))
        return "Usernames can only contain letters, numbers, and underscores";
    if (/_{2}/.test(name))
        return "Usernames cannot contain 2 consecutive underscores";

    return null;
}


export function getDisplayNameError(name: string): string | null {
    if (name.length < 3)
        return "Display name must be at least 3 characters long";
    if (name.length > MAX_DISPLAY_NAME_LENGTH)
        return `Display name cannot be longer than ${MAX_DISPLAY_NAME_LENGTH} characters`;

    const charactersRegEx = /^[a-zA-Z0-9_ ]+$/;
    if (!charactersRegEx.test(name)) {
        for (let index = 0; index < name.length; ++index) {
            if (!charactersRegEx.test(name[index]))
                return `Display name cannot contain the '${name[index]}' character`;
        }
    }
    return null;
}


export function getAgreedToPoliciesError(agreed: boolean): string | null {
    return agreed ? null : "You must agree to the Terms & Conditions and Privacy Policy";
}


export function isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function getEmailError(email: string): string | null {
    return (isValidEmail(email) ? null : "Invalid email address");
}


export type PasswordRules = [string, boolean][];


export function checkPasswordRules(password: string): PasswordRules {
    return [
        ["Password must contain at least 8 characters", password.length >= 8],
        ["Password must contain at least 1 number", /[0-9]/.test(password)],
        ["Password must contain at least 1 uppercase letter", /[A-Z]/.test(password)],
        ["Password must contain at least 1 lowercase letter", /[a-z]/.test(password)],
        ["Password must not start or end with whitespace", !/^\s|\s$/.test(password)],
    ];
}


export function getPasswordError(rules: PasswordRules): string | null {
    for (const [rule, pass] of rules) {
        if (!pass)
            return rule;
    }
    return null;
}

export function getPasswordSignupError(rawEmail: string, password: string): string | null {
    const emailError = getEmailError(rawEmail);
    if (emailError)
        return emailError;

    const passwordRules = checkPasswordRules(password);
    const passwordError = getPasswordError(passwordRules);
    if (passwordError)
        return passwordError;

    return null;
}
